var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { api } from '../../helpers/Api';
import { action, observable } from 'mobx';
var Store = /** @class */ (function () {
    function Store() {
        var _this = this;
        this.availablePayments = [];
        this.setAvailablePayments = function (availablePayments) {
            console.log('setAvailablePayments - availablePayments: ', availablePayments);
            if (availablePayments && availablePayments.result === 'ok' && availablePayments.payload.length > 0) {
                var noDisabled = availablePayments.payload.filter(function (p) { return !p.disabled_at; });
                console.log('setAvailablePayments - noDisabled: ', noDisabled);
                _this.availablePayments = noDisabled;
            }
            else {
                _this.availablePayments = [];
            }
            return _this.availablePayments;
        };
    }
    Store.prototype.getPaymentTokens = function (agency_id) {
        return api.get("agencies/".concat(agency_id, "/paymentCards")).then(this.setAvailablePayments)
            .catch(function (err) {
            console.log(err);
        });
    };
    Store.prototype.addPaymentToken = function (_a) {
        var account = _a.account, agency = _a.agency;
        // console.log('account: ', account)
        var data = {
            agency_id: agency.id,
            publicToken: account.publicToken,
            pasarelaPago: PaymentGateways.MSP,
            environment: process.env.REACT_APP_ENVIRONMENT
        };
        return api.post("payment/token/zeroauth", data);
    };
    __decorate([
        observable
    ], Store.prototype, "availablePayments", void 0);
    __decorate([
        action
    ], Store.prototype, "setAvailablePayments", void 0);
    return Store;
}());
export default Store;
export var PaymentGateways = Object.freeze({
    TMT: 'TRUSTMYTRAVEL',
    MSP: 'MULTISAFEPAY',
    PNP: 'PAYNOPAIN',
    STRIPE: 'STRIPE',
    GREENPAY: 'GREEPAY',
    CREDOMATIC: 'CREDOMATIC'
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/PaymentGateways/Store.ts
// module id = 763
// module chunks = 0